import React from 'react';
import ProfileTableLayout from 'UI/components/organisms/inventoryProfiles/ProfileTableLayout';
import { componentDimensions } from 'UI/constants/dimensions';
import { Endpoints } from 'UI/constants/endpoints';
import { TabKeys } from 'UI/constants/entityTypes';
import { SvgNoSearchProjects } from 'UI/res/icons/milano';

import { columns, virtualProps } from './columns';

const { emptyState } = componentDimensions;

/**
 * @param {Object} props
 * @param {string} props.endpoint
 * @param {Function} props.onOpenAddToSearchProjectForm
 * @param {Function} props.onRemoveProfileFromSearchProject
 * @param {string} props.copies
 * @param {string} props.profileId
 * @param {boolean} props.shouldRefresh
 */
const SearchProjectsTab = ({
  copies,
  endpoint,
  onOpenAddToSearchProjectForm,
  onRemoveProfileFromSearchProject,
  profileId,
  shouldRefresh,
  ...rest
}) => {
  const finalActions = [
    {
      callback: ({ searchProjectId, searchProjectName }) => {
        const searchProject = {
          searchProjectId,
          copies: {
            removeDialog: copies.getRemoveDialogCopies(searchProjectName.searchProjectName)
          }
        };
        onRemoveProfileFromSearchProject && onRemoveProfileFromSearchProject(searchProject);
      },
      idKey: 'searchProjectId',
      name: 'remove',
      checkIfShouldBeEnabled: ({ rowIndex }, data) => data[rowIndex].isCollaborator
    }
  ];
  const DataTableProps = {
    endpoint: `${endpoint}/${Endpoints.SearchProjects}`,
    virtualProps
  };

  const handleOpenAddToSPForm = () =>
    onOpenAddToSearchProjectForm && onOpenAddToSearchProjectForm();

  return (
    <ProfileTableLayout
      customEmptyState={<SvgNoSearchProjects size={emptyState.width} />}
      DataTableProps={DataTableProps}
      finalActions={finalActions}
      initialColumns={columns}
      onNewItemClick={handleOpenAddToSPForm}
      orderByOptions={{ column: 'addedDate', direction: 'desc' }}
      tabKey={TabKeys.SearchProjects}
      hasProfileLoaded={profileId}
      shouldRefresh={shouldRefresh}
      {...rest}
      {...copies.tab}
    />
  );
};

SearchProjectsTab.defaultProps = {
  onOpenAddToSearchProjectForm: () => {},
  onRemoveProfileFromSearchProject: () => {},
  copies: ''
};

export default SearchProjectsTab;
